export const SUPPORTED_LANGUAGES = [
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'en', name: 'English', flag: '🌐' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export const DEFAULT_LANGUAGE: LanguageCode = 'pl';

export const CURRENCY_BY_LANGUAGE: Record<LanguageCode, string> = {
  pl: 'PLN',
  en: 'USD',
};

export const CURRENCY_SYMBOL_BY_LANGUAGE: Record<LanguageCode, string> = {
  pl: 'zł',
  en: '$',
};
